<template>
    <div :id="rootId" :ignore-escape="ignoreEscape" :class="rootClasses" tabindex="-1">
        <div class="modal-content" :class="modalWidth" ref="content">
            <div>
                <slot name="modal-content"></slot>
                <div class="modal-container">
                    <slot name="modal-container"></slot>
                </div>
            </div>
        </div>
        <div class="modal-backdrop"></div>
    </div>
</template>
<script>
export default {
    props: {
        id: String,
        ignoreEscape: Boolean,
        rootClasses: String,
        rootId: String,
        modalWidth: String,
    },

    mounted() {
        $('body, html').addClass('overflow-hidden');
    },
};
</script>
